// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__kI8k8","icon":"styles_icon__hVTob","google":"styles_google__PoG99"};